import { fetchCurrentUser } from '../../ducks/user.duck';
import { denormalisedResponseEntities } from '../../util/data';
import { storableError } from '../../util/errors';
import { LISTING_STATE_PUBLISHED } from '../../util/types';

// ================ Action types ================ //

export const FETCH_LISTINGS_REQUEST = 'app/EnquirySettingsPage/FETCH_LISTINGS_REQUEST';
export const FETCH_LISTINGS_SUCCESS = 'app/EnquirySettingsPage/FETCH_LISTINGS_SUCCESS';
export const FETCH_LISTINGS_ERROR = 'app/EnquirySettingsPage/FETCH_LISTINGS_ERROR';
export const UPDATE_REQUEST = 'app/EnquirySettingsPage/UPDATE_REQUEST';
export const UPDATE_SUCCESS = 'app/EnquirySettingsPage/UPDATE_SUCCESS';
export const UPDATE_ERROR = 'app/EnquirySettingsPage/UPDATE_ERROR';

// ================ Reducer ================ //

const initialState = {
  // The tester's published listings: the toggle applies to all of them.
  listings: [],
  fetchInProgress: false,
  fetchError: null,
  updateInProgress: false,
  updateError: null,
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case FETCH_LISTINGS_REQUEST:
      return { ...state, fetchInProgress: true, fetchError: null };
    case FETCH_LISTINGS_SUCCESS:
      return { ...state, fetchInProgress: false, listings: payload };
    case FETCH_LISTINGS_ERROR:
      return { ...state, fetchInProgress: false, fetchError: payload };
    case UPDATE_REQUEST:
      return { ...state, updateInProgress: true, updateError: null };
    case UPDATE_SUCCESS:
      return { ...state, updateInProgress: false, listings: payload };
    case UPDATE_ERROR:
      return { ...state, updateInProgress: false, updateError: payload };
    default:
      return state;
  }
}

// ================ Action creators ================ //

const fetchListingsRequest = () => ({ type: FETCH_LISTINGS_REQUEST });
const fetchListingsSuccess = listings => ({ type: FETCH_LISTINGS_SUCCESS, payload: listings });
const fetchListingsError = e => ({ type: FETCH_LISTINGS_ERROR, error: true, payload: e });
const updateRequest = () => ({ type: UPDATE_REQUEST });
const updateSuccess = listings => ({ type: UPDATE_SUCCESS, payload: listings });
const updateError = e => ({ type: UPDATE_ERROR, error: true, payload: e });

// ================ Thunks ================ //

export const fetchOwnListings = () => (dispatch, getState, sdk) => {
  dispatch(fetchListingsRequest());
  return sdk.ownListings
    .query({ perPage: 100 })
    .then(response => {
      const listings = denormalisedResponseEntities(response).filter(
        l => l.attributes.state === LISTING_STATE_PUBLISHED
      );
      dispatch(fetchListingsSuccess(listings));
    })
    .catch(e => dispatch(fetchListingsError(storableError(e))));
};

export const setAcceptingEnquiries = accepting => (dispatch, getState, sdk) => {
  const { listings } = getState().EnquirySettingsPage;
  const publicData = { enquiriesPaused: !accepting };

  dispatch(updateRequest());
  return Promise.all(
    listings.map(listing =>
      sdk.ownListings.update({ id: listing.id, publicData }, { expand: true })
    )
  )
    .then(responses => {
      dispatch(updateSuccess(responses.map(r => denormalisedResponseEntities(r)[0])));
    })
    .catch(e => dispatch(updateError(storableError(e))));
};

export const loadData = () => dispatch => {
  dispatch(fetchCurrentUser());
  return dispatch(fetchOwnListings());
};
